import { Injectable } from '@angular/core';

import { BaseService } from 'app/_services/base.service';
import { SettingsService } from 'app/_services/settings.service';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HoldingSupplierForEdit } from './_models/holdingSupplierForEdit';

@Injectable({ providedIn: 'root' })
export class SupportHoldingsBillingDataManagementService extends BaseService
{
    private _apiSupportUrl: string = `${environment.apiSupport}`;
    private _domain: string = '/suppliers/holdings/billing-data';
    public pageSize: number = 15;

    constructor(private config: SettingsService, private http: HttpClient) {
        super();
    }

    public addPaymentEndDate(holdingId: number, endDdate: Date): Observable<any> {
        var body = {
            endDate: endDdate
        };

        return this.config.executePut({ baseUrl: this._apiSupportUrl, url: `${this._domain}/${holdingId}/payments`, body });
    }

    public createHoldingPayment(holdingId: number, startDate: Date): Observable<any> {
        var body = {
            startDate: startDate
        };

        return this.config.executePost({ baseUrl: this._apiSupportUrl, url: `${this._domain}/${holdingId}/payments`, body });
    }

    public deleteHoldingPayment(holdingId: number, paymentId: number): Observable<any> {
        return this.config.executeDelete({ baseUrl: this._apiSupportUrl, url: `${this._domain}/${holdingId}/payments/${paymentId}` });
    }

    public editHoldingBillingData(holding: HoldingSupplierForEdit) {
        return this.config.executePut({ baseUrl: this._apiSupportUrl, url: `${this._domain}/${holding.holdingId}`, body: holding });
    }

    public editHoldingBillingDataWithPayment(holding: HoldingSupplierForEdit) {
        return this.config.executePut({ baseUrl: this._apiSupportUrl, url: `${this._domain}/${holding.holdingId}/with-payment`, body: holding });
    }

    public getById(holdingId: string) {
        return this.config.executeGet({ baseUrl: this._apiSupportUrl, url: `${this._domain}/${holdingId}`});
    }

    public getByPage(pageNumber: number, filter: string = ''): Observable<any> {
        return this.config.executeGet({ baseUrl: this._apiSupportUrl, url: `${this._domain}/management?currentPage=${pageNumber}&pageSize=${this.pageSize}&nameFilter=${filter}`});
    }

    public getHoldingPayments(holdingId: number): Observable<any> {
        return this.config.executeGet({ baseUrl: this._apiSupportUrl, url: `${this._domain}/${holdingId}/payments`});
    }

    public getSupplierRepairerComissions(holdingId: number): Observable<any> {
        return this.config.executeGet({ baseUrl: this._apiSupportUrl, url: `${this._domain}/${holdingId}/custom-comission`});
    }

    public getSupplierRepairers(holdingId: number, isBillable: boolean): Observable<any> {
        return this.config.executeGet({ baseUrl: this._apiSupportUrl, url: `${this._domain}/${holdingId}/repairers?isSupplierBillable=${isBillable}`});
    }

    public saveCustomComission(holdingId: number, repairerId: number, comissionValue: number): Observable<any> {
        var body = {
            comissionValue: comissionValue
        };

        return this.config.executePost({ baseUrl: this._apiSupportUrl, url: `${this._domain}/${holdingId}/repairers/${repairerId}/custom-comission`, body });
    }

    public removeCustomComission(holdingId: number, repairerId: number): Observable<any> {
        return this.config.executeDelete({ baseUrl: this._apiSupportUrl, url: `${this._domain}/${holdingId}/repairers/${repairerId}/custom-comission` });
    }
}
